import { render, staticRenderFns } from "./ProgramDashboardPage.vue?vue&type=template&id=074821b3"
import script from "./ProgramDashboardPage.vue?vue&type=script&lang=js"
export * from "./ProgramDashboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports